/* NICO-LS 記事ページの読みやすさ強化
   2026-09-02 追加。
   - 本文の H2 / H3 から目次を組み立て、いま読んでいる節をハイライトする
   - 上部に読了プログレスバーを出す
   - 横に長い表をスクロールできるように包む
   本文の HTML は書き換えない（見出しに id を振るのと、表を div で包むだけ）。 */
(function () {
  'use strict';

  var content = document.querySelector('.article-template__content');
  if (!content) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // --- 見出しに id を振る（既にあれば尊重する） ---
  var used = Object.create(null);
  function slug(text, i) {
    var base = 'sec-' + (i + 1);
    if (used[base]) base += '-' + Math.random().toString(36).slice(2, 6);
    used[base] = true;
    return base;
  }

  var headings = Array.prototype.slice.call(content.querySelectorAll('h2, h3'));
  headings.forEach(function (el, i) {
    if (!el.id) el.id = slug(el.textContent, i);
  });

  // --- 目次 ---
  var mount = document.querySelector('[data-nls-toc]');
  // H2 が3本未満の記事に目次は要らない
  var h2count = headings.filter(function (el) { return el.tagName === 'H2'; }).length;
  if (mount && h2count >= 3) {
    var list = document.createElement('ol');
    list.className = 'nls-toc__list';
    list.id = 'nls-toc-list';

    headings.forEach(function (el) {
      var li = document.createElement('li');
      li.className = 'nls-toc__item' + (el.tagName === 'H3' ? ' nls-toc__item--h3' : '');
      var a = document.createElement('a');
      a.href = '#' + el.id;
      a.textContent = (el.textContent || '').trim();
      li.appendChild(a);
      list.appendChild(li);
      el.__tocItem = li;
    });

    var head = document.createElement('div');
    head.className = 'nls-toc__head';
    var title = document.createElement('p');
    title.className = 'nls-toc__title';
    title.textContent = 'もくじ';
    var toggle = document.createElement('button');
    toggle.className = 'nls-toc__toggle';
    toggle.type = 'button';
    toggle.textContent = '閉じる';
    toggle.setAttribute('aria-expanded', 'true');
    toggle.setAttribute('aria-controls', 'nls-toc-list');
    toggle.addEventListener('click', function () {
      var open = !list.hidden;
      list.hidden = open;
      toggle.textContent = open ? '開く' : '閉じる';
      toggle.setAttribute('aria-expanded', String(!open));
    });
    head.appendChild(title);
    head.appendChild(toggle);

    mount.className = 'nls-toc';
    mount.appendChild(head);
    mount.appendChild(list);

    // いま画面にある見出しを現在地にする
    if ('IntersectionObserver' in window) {
      var current = null;
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            if (current) current.classList.remove('is-current');
            current = e.target.__tocItem;
            if (current) current.classList.add('is-current');
          });
        },
        { rootMargin: '0px 0px -75% 0px', threshold: 0 }
      );
      headings.forEach(function (el) { io.observe(el); });
    }
  }

  // --- 読了プログレスバー ---
  var bar = document.createElement('div');
  bar.className = 'nls-progress';
  bar.setAttribute('aria-hidden', 'true');
  document.body.appendChild(bar);

  var ticking = false;
  function update() {
    var rect = content.getBoundingClientRect();
    var total = rect.height - window.innerHeight;
    var done = -rect.top;
    var pct = total > 0 ? Math.min(100, Math.max(0, (done / total) * 100)) : 0;
    bar.style.width = pct + '%';
    ticking = false;
  }
  function onScroll() {
    if (ticking) return;
    ticking = true;
    if (reduce) update();
    else window.requestAnimationFrame(update);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  update();

  // --- 横に長い表を包む ---
  Array.prototype.forEach.call(content.querySelectorAll('table'), function (t) {
    if (t.parentElement && t.parentElement.classList.contains('nls-table-scroll')) return;
    var w = document.createElement('div');
    w.className = 'nls-table-scroll';
    t.parentNode.insertBefore(w, t);
    w.appendChild(t);
  });
})();
